import { useUTM } from '@repo/platform';
import { useEffect, useRef, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

import { ScrollEventWrapper } from '@/components/common/ScrollEventWrapper';
import { LandingSectionProps } from '@/lib/constants/home';

export const MainItem = ({ sectionId, className }: LandingSectionProps) => {
  const [partnerImageName, setPartnerImageName] = useState('');
  const { utmData } = useUTM();

  useIsomorphicLayoutEffect(() => {
    const utmSource = utmData?.utmSource ?? '';
    if (['imbank', 'kbcardevent', 'kakaopay'].includes(utmSource)) {
      setPartnerImageName(`-${utmSource}`);
    }
  }, [utmData]);

  return (
    <ScrollEventWrapper sectionId={sectionId}>
      <div className={`flex justify-center ${className}`}>
        <div className={'w-full max-w-[700px]'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/landing/main-introduce${partnerImageName}.png`} alt="main-introduce" />
        </div>
      </div>
    </ScrollEventWrapper>
  );
};

export const RefundProcess = ({ sectionId, className }: LandingSectionProps) => {
  return (
    <ScrollEventWrapper sectionId={sectionId} threshold={0.6}>
      <div className={`flex justify-center ${className}`}>
        <div className={'w-full max-w-[700px]'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/landing/refund-process.png`} alt="refund-process" loading={'lazy'} />
        </div>
      </div>
    </ScrollEventWrapper>
  );
};

export const CompanyComparison = ({ sectionId, className }: LandingSectionProps) => {
  return (
    <ScrollEventWrapper sectionId={sectionId}>
      <div className={`flex justify-center ${className}`}>
        <div className={'w-full max-w-[700px]'}>
          <img
            src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/landing/company-comparison.png`}
            alt="trust-company-comparison"
            loading={'lazy'}
          />
        </div>
      </div>
    </ScrollEventWrapper>
  );
};

export const RefundPolicy = ({ sectionId, className }: LandingSectionProps) => {
  return (
    <ScrollEventWrapper sectionId={sectionId}>
      <div className={`flex justify-center ${className}`}>
        <div className={'w-full max-w-[700px]'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/landing/refund-policy.png`} alt="refund-policy" />
        </div>
      </div>
    </ScrollEventWrapper>
  );
};

export const LookupCondition = ({ sectionId, className }: LandingSectionProps) => {
  return (
    <ScrollEventWrapper sectionId={sectionId}>
      <div className={`flex justify-center ${className}`}>
        <div className={'w-full max-w-[700px]'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/landing/lookup-condition.png`} alt="lookup-condition" loading={'lazy'} />
        </div>
      </div>
    </ScrollEventWrapper>
  );
};

export const RefundExample = ({ sectionId, className }: LandingSectionProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [screenType, setScreenType] = useState<'mobile' | 'pc'>('pc');

  useEffect(() => {
    const containerEl = containerRef.current;
    if (!containerEl) return () => {};

    const resizeObserver = new ResizeObserver(([entry]) => {
      if (!entry) return;

      const fullWidth = entry.contentRect.width;

      setScreenType(fullWidth < 700 ? 'mobile' : 'pc');
    });

    resizeObserver.observe(containerEl);

    return () => {
      resizeObserver.unobserve(containerEl);
    };
  }, [screenType]);

  return (
    <ScrollEventWrapper sectionId={sectionId} threshold={screenType === 'mobile' ? 0.5 : 0.75}>
      <div ref={containerRef} className={`flex justify-center ${className}`}>
        <div className={'w-full max-w-[700px]'}>
          <img
            src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/landing/refund-example-${screenType}.png`}
            alt="refund-example"
            loading={'lazy'}
          />
        </div>
      </div>
    </ScrollEventWrapper>
  );
};
